module.exports = __webpack_public_path__ + "static/img/1-15.7f3febf.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-15.png
// module id = 57
// module chunks = 0